import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom'; 
import * as Authservices from '../Services/services';

const Breadcrumbs = () => {
    const location = useLocation();
    const [dynamicBreadcrumbName, setDynamicBreadcrumbName] = useState(null);
    
    const currentRoute = location.pathname;

    // Update the dynamic breadcrumb name based on the route
    useEffect(() => {
        const pathParts = currentRoute.split('/').filter(Boolean);
        if (pathParts[0] === 'series' && pathParts[1] && !isNaN(pathParts[1])) {
            Authservices.getSeriesDetails({ series_id: parseInt(pathParts[1]) })
                .then(res => {
                    const body = res.data;
                    const title = body?.responseDetails?.title || body?.data?.title;
                    setDynamicBreadcrumbName(title || null);
                })
                .catch(() => setDynamicBreadcrumbName(null));
        } else {
            setDynamicBreadcrumbName(null);
        }
    }, [currentRoute]);

    // Function to format breadcrumb segment (like 'content', 'movies', etc.)
    const formatBreadcrumb = (segment, index, arr) => {
        if (index === arr.length - 1 && dynamicBreadcrumbName) {
            return dynamicBreadcrumbName;
        }
        if (!isNaN(segment)) return `ID: ${segment}`;

        // Custom mapping for paths that don't match their display labels
        const routeMap = {
            'genres': 'Categories',
            'tags': 'Genres',
            'types': 'Tags',
            'plans': 'Coin Plans',
            'vip-plans': 'VIP Plans',
            'curated': 'Curated Collection'
        };

        if (routeMap[segment]) return routeMap[segment];

        return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
    };

    // Generate breadcrumb segments
    const generateBreadcrumbs = () => {
        const pathSegments = currentRoute.split('/').filter(Boolean);
        const breadcrumbs = pathSegments.map((segment, index) => {
            const path = '/' + pathSegments.slice(0, index + 1).join('/');
            return { name: segment, path };
        });

        return breadcrumbs;
    };

    return (
        <div className="breadcrumbs">
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to="/">Home</Link>
                    </li>
                    {generateBreadcrumbs().map((crumb, index, arr) => (
                        <li
                            key={crumb.path}
                            className={`breadcrumb-item ${index === arr.length - 1 ? 'active' : ''}`}
                            aria-current={index === arr.length - 1 ? 'page' : undefined}
                        >
                            {index === arr.length - 1 ? (
                                formatBreadcrumb(crumb.name, index, arr)
                            ) : (
                                <Link to={crumb.path}>{formatBreadcrumb(crumb.name, index, arr)}</Link>
                            )}
                        </li>
                    ))}
                </ol>
            </nav>
        </div>
    );
};

export default Breadcrumbs;
